export default __webpack_public_path__ + "static/media/europeanUnion.c8a22e89.svg";